import { useEffect, useMemo, useRef, useState } from "react";
import MTable from "../../../components/mtable";
import { formatDate, formatMonth, renderPerson } from "./MonthDrilldown";

// Accepted matches show just the partner; earlier stages get a label above the name
const MATCH_STAGE_LABEL = { Preview: "Awaiting approval", Proposed: "Awaiting response" };

const renderMatch = (item) => {
    if (!item.match) return <p className="card-label neutral">No match yet</p>;
    const stage = MATCH_STAGE_LABEL[item.match.status];
    return (
        <div>
            {stage && <p className="card-label neutral">{stage}</p>}
            {renderPerson(item.match.partner)}
        </div>
    );
};

const mapper = {
    columns: [
        { label: "Participant", width: "2fr", render: (item) => renderPerson(item.user) },
        { label: "Role", value: (item) => item.role },
        { label: "Enrolled", value: (item) => formatDate(item.enrolledAt) },
        { label: "Match", width: "2fr", render: renderMatch },
    ],
};

// Remounted per month by the parent (key={month}), so state starts fresh and
// a late response for a previously selected month can't land in this panel
export default function EnrollmentDrilldown({ programId, month, startDate, endDate, onClose }) {
    const [total, setTotal] = useState(null);
    const panelRef = useRef(null);

    // MTable refetches whenever queryParams changes identity, so keep it stable
    const queryParams = useMemo(() => ({ startDate, endDate }), [startDate, endDate]);

    useEffect(() => {
        panelRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, []);

    return (
        <div ref={panelRef} className="vi-spacer-s">
            <div className="flex center space-between gap-xs v-spacer-xs">
                <p className="section-title-s">{formatMonth(month)}</p>
                <button className="with-icon icon outline" onClick={onClose}>
                    <span className="material-symbols-outlined scale-s">close</span>
                </button>
            </div>

            {total > 0 && (
                <p className="v-spacer-xs">
                    {total} {total === 1 ? "enrollment" : "enrollments"}
                </p>
            )}

            <MTable
                path={`programs/${programId}/timeseries/enrollments/${month}`}
                queryParams={queryParams}
                mapper={mapper}
                onMeta={(meta) => setTotal(meta.total)}
                autoHideNavigation
                emptyState={
                    <div className="dashed-card standard-padding">
                        <p className="card-title">No enrollments this month</p>
                    </div>
                }
            />
        </div>
    );
}